import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';


export default function ChatGPTScreen(){
    const [country, setCountry] = useState("");
    const [countryList, setCountryList] = useState([]);
    const adminSignin = useSelector((state) => state.adminSignin);
    const { adminInfo } = adminSignin;
    const navigate = useNavigate();

    const chatGPTAPI = async (path) => {
        try {
            const response = await fetch(`https://optrip.workingfromhammock.com/openai/${path}?country=${country}`);
            const data = await response.json();
            if (response.status === 200) {
                console.log("ChatGPT API Response:", data);
                alert(data[0].message);
            }
        } catch (error) {
            console.error("Error fetching ChatGPT API:", error);
        }
    };

    useEffect(() => {
        const fetchCountry = async () => {
            try {
                const response = await axios.get('/api/admin/optrip/country', {
                    headers: {
                        Authorization: `Bearer ${adminInfo.token}`,
                    },
                });
                if (response.status !== 200) {
                    throw new Error('Failed to fetch countries');
                }
                setCountryList(response.data);
            } catch (error) {
                console.error('Error fetching countries:', error);
            }
        };
        fetchCountry();
    }, [adminInfo.token]);

    useEffect(()=> {
        if(!adminInfo){
            navigate("/signin");
        }
    },[adminInfo,navigate]);
    return(
         <div className='row'>
            <div className='button-container col-lg-6 col-md-8 col-sm-10 col-xs-12 mt-10 pt-10 ' >

                {adminInfo.role_edit ? <div className='dis-button ' >
                    <select  value={country} onChange={(e) => setCountry(e.target.value)}>
                        <option value="">Select A Country</option>
                        {countryList.map((country, index) => (
                            <option key={index} value={country.country}>
                                {country.country}
                            </option>
                        ))}
                    </select>
                </div> : <></>}
                {adminInfo.role_edit ? <div className='dis-button' >
                    <button className='button' onClick={() => {chatGPTAPI("request")}}> ChatGPT Request </button>
                </div> : <></>}
                {adminInfo.role_edit ? <div className='dis-button' >
                    <button className='button' onClick={() => {chatGPTAPI("status")}}> ChatGPT Status </button>
                </div> : <></>}
                {adminInfo.role_edit ?<div >
                    <button className='button' onClick={() => {chatGPTAPI("retrieve")}}> ChatGPT Retrieve </button>
                </div> : <></>}
                {/*adminInfo.role_edit ?<div className='dis-button' >
                    <button className='button' onClick={() => {chatGPTAPI("calculate")}}> Calculate Rating </button>
                </div> : <></>*/}
                
                
          </div>
        </div>
    );
}